type CartLineVariant = {
  variant?: { key?: string; sku?: string };
};

export const matchesCartVariant = (
  variant: CartLineVariant['variant'],
  variantSku: string | undefined
): boolean =>
  Boolean(
    variantSku && (variant?.key === variantSku || variant?.sku === variantSku)
  );

/**
 * Whether the cart already holds a line for this variant. commercetools merges
 * a repeated variant into that line by bumping its quantity, which for paid
 * UPM is the seat count, so callers must check this before appending.
 */
export const hasCartLine = (
  cart: { lineItems?: readonly CartLineVariant[] } | undefined,
  variantSku: string | undefined
): boolean =>
  Boolean(
    variantSku &&
    cart?.lineItems?.some(({ variant }) =>
      matchesCartVariant(variant, variantSku)
    )
  );
